import { render, staticRenderFns } from "./SearchBoostingForm.vue?vue&type=template&id=333240fa&scoped=true&"
import script from "./SearchBoostingForm.vue?vue&type=script&lang=js&"
export * from "./SearchBoostingForm.vue?vue&type=script&lang=js&"
import style0 from "./SearchBoostingForm.vue?vue&type=style&index=0&id=333240fa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "333240fa",
  null
  
)

export default component.exports